import { useSelector } from 'react-redux';

import { useWishlistActionMutation } from 'src/store/api/accounts/accountsApiSlice';
import { authSelector } from 'src/store/reducers/auth';
import type { WishlistProductTarget } from 'src/types/wishlist/Wishlist';
import {
    addGuestWishlistItem,
    removeGuestWishlistItem,
} from 'src/utils/guestWishlist';
import { useError } from 'src/hooks';


const useWishlist = () => {
    const [wishlistToggle] = useWishlistActionMutation();
    const { showError } = useError();
    const auth = useSelector(authSelector);

    const actionHandle = async (action: "add" | "remove", product: WishlistProductTarget) => {
        try {
            if (!auth.access) {
                if (action === "add") {
                    addGuestWishlistItem(product);
                } else {
                    removeGuestWishlistItem(product);
                }

                return true;
            }

            await wishlistToggle({ product_id: product.id, action }).unwrap();
            return true;
        }
        catch (error) {
            showError(error);
            return false;
        }
    }

    const wishlistAdding = (product: WishlistProductTarget) => {
        return actionHandle('add', product);
    }

    const wishlistRemoving = async (product: WishlistProductTarget) => {
        return actionHandle('remove', product);
    }

    return { wishlistAdding, wishlistRemoving };
};

export default useWishlist;
